import { render, staticRenderFns } from "./collectDoc.vue?vue&type=template&id=97d2aa6e&"
import script from "./collectDoc.vue?vue&type=script&lang=js&"
export * from "./collectDoc.vue?vue&type=script&lang=js&"
import style0 from "./collectDoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports